// extracted by mini-css-extract-plugin
export default {"page":"page-admin_page__GOJ+w"};